module.exports = __webpack_public_path__ + "static/img/4.a3a88d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/sp/4.png
// module id = oeDA
// module chunks = 0